/* eslint-disable react/self-closing-comp */
import {
  AmplifyAuthContainer,
  AmplifyAuthenticator,
  AmplifySignIn,
} from "@aws-amplify/ui-react";

const AmplifyAuth = () => {
  return (
    <AmplifyAuthContainer>
      <AmplifyAuthenticator usernameAlias="email">
        <AmplifySignIn
          hideSignUp="true"
          usernameAlias="email"
          slot="sign-in"
        ></AmplifySignIn>
      </AmplifyAuthenticator>
    </AmplifyAuthContainer>
  );
};

export default AmplifyAuth;
